import type { NotificationTransitionObservationCardProps } from "./notification-transition-observation-card.type";

import { Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";

import { BatchPreviewTransitionLink } from "@/modules/batch-preview/batch-preview-transition-link";
import ModelIcon from "@/modules/model-icon";
import { ModelLink } from "@/modules/model-link";
import { NotificationCard } from "@/modules/notification/notification-card";
import { useNotificationsPanel } from "@/modules/notifications/notifications-panel";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";
import { StateTag } from "@/modules/state-tag";

const { Paragraph } = Typography;

export const NotificationTransitionObservationCard = ({
  notification,
}: NotificationTransitionObservationCardProps) => {
  const { t } = useTranslation();
  const { closePanel } = useNotificationsPanel();

  const { type, data } = notification;
  const { context, state, observations, user } = data;
  const color = "var(--app-color-info)";
  const count = observations.length;
  const ids = observations.map(({ id }) => id);

  return (
    <NotificationCard
      notification={notification}
      icon={<ModelIcon model="observation" style={{ color }} />}
      title={t("notification:observationTransition.title", { count })}
      color={color}
      subTitle={user.name}
      content={
        <Paragraph ellipsis={{ rows: 2 }}>
          <Trans
            i18nKey="notification:observationTransition.description"
            values={{
              userName: user.name,
              observationName: observations[0]?.name ?? "",
              count,
            }}
            components={{
              StateTag: <StateTag value={state} type="observation" asText />,
            }}
          />
        </Paragraph>
      }
      actions={
        <>
          {count === 1 ? (
            <ModelLink
              model="observation"
              item={observations[0]}
              showIcon="external"
              modelAsName
              customContext={context}
              onClick={closePanel}
            />
          ) : (
            <BatchPreviewTransitionLink
              type={type}
              state={state}
              userId={user.id}
              ids={ids}
              customContext={context}
              onClick={closePanel}
              icon="external"
            />
          )}
          <OrganizationContextLabel context={context} isSmall />
        </>
      }
    />
  );
};
